var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M21 22.75H3C2.59 22.75 2.25 22.41 2.25 22C2.25 21.59 2.59 21.25 3 21.25H21C21.41 21.25 21.75 21.59 21.75 22C21.75 22.41 21.41 22.75 21 22.75Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M5.6 8.37988H4C3.45 8.37988 3 8.82988 3 9.37988V17.9999C3 18.5499 3.45 18.9999 4 18.9999H5.6C6.15 18.9999 6.6 18.5499 6.6 17.9999V9.37988C6.6 8.81988 6.15 8.37988 5.6 8.37988Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M12.8 5.18994H11.2C10.65 5.18994 10.2 5.63994 10.2 6.18994V17.9999C10.2 18.5499 10.65 18.9999 11.2 18.9999H12.8C13.35 18.9999 13.8 18.5499 13.8 17.9999V6.18994C13.8 5.63994 13.35 5.18994 12.8 5.18994Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M20 2H18.4C17.85 2 17.4 2.45 17.4 3V18C17.4 18.55 17.85 19 18.4 19H20C20.55 19 21 18.55 21 18V3C21 2.45 20.55 2 20 2Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }